function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5161_5389)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.9987 1.33325C4.3187 1.33325 1.33203 4.31992 1.33203 7.99992C1.33203 11.6799 4.3187 14.6666 7.9987 14.6666C11.6787 14.6666 14.6654 11.6799 14.6654 7.99992C14.6654 4.31992 11.6787 1.33325 7.9987 1.33325ZM8.66536 12.6666H7.33203V11.3333H8.66536V12.6666ZM10.0454 7.49992L9.44536 8.11325C9.11203 8.45325 8.87203 8.75992 8.75203 9.23992C8.6987 9.45325 8.66536 9.69325 8.66536 9.99992H7.33203V9.66658C7.33203 9.35992 7.38536 9.06658 7.4787 8.79325C7.61203 8.40658 7.83203 8.05992 8.11203 7.77992L8.9387 6.93992C9.24536 6.64658 9.39203 6.20658 9.30536 5.73992C9.2187 5.25992 8.84536 4.85325 8.3787 4.71992C7.6387 4.51325 6.95203 4.93325 6.73203 5.56659C6.65203 5.81325 6.44536 5.99992 6.18536 5.99992H5.98536C5.5987 5.99992 5.33203 5.62659 5.4387 5.25325C5.72536 4.27325 6.5587 3.52659 7.59203 3.36659C8.60536 3.20659 9.57203 3.73325 10.172 4.56659C10.9587 5.65325 10.7254 6.81992 10.0454 7.49992Z",
  fill: "#B6B9BB"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5161_5389"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.e5999721.svg";
export { ForwardRef as ReactComponent };